import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { getCountryOptions } from '../../api/codelist/codeListsSlice';

const CountrySelect = ({
  name,
  label = 'Country',
  control,
  errors,
  readOnly = false,
  disabled,
  onChange,
  allowedCodes,
}) => {
  const countryCodeOptions = useSelector(getCountryOptions);
  const options =
    allowedCodes?.length > 0
      ? countryCodeOptions.filter((option) => allowedCodes.includes(option.code))
      : countryCodeOptions;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Autocomplete
            {...field}
            id={name}
            data-testid={`${name}-select`}
            options={options}
            readOnly={readOnly}
            getOptionLabel={(option) => (option.code ? `${option.label} (${option.code})` : '')}
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid={`${name}-input`}
                label={label}
                error={!!get(errors, name, null)}
                helperText={get(errors, name, {})?.message}
              />
            )}
            isOptionEqualToValue={(option, value) => option.code === value?.code}
            onChange={(_, value) => {
              field.onChange(value);
              onChange?.(value);
            }}
            value={field.value || null} // handle default value
            disabled={disabled}
          />
        );
      }}
    />
  );
};

export default CountrySelect;
